<ng-container msScrolledToBottom [scrollContext]="'document'" (scrollAtBottom)="getMore()">
    <ng-container *ngIf="vm$ | async as vm">
        <ng-container *ngFor="let column of vm.columns; trackBy: trackByIndex">
            <div
                class="option-group-column"
                [class.option-group-column--mobile]="deviceService.isMobilePhone"
                [class.two-column]="!vm.forceSingleColumn && vm.columns.length === 2">
                <ng-container *ngFor="let optionGroup of column | slice: 0 : vm.limit; trackBy: trackByFn">
                    <ms-option-panel
                        *rxIf="
                            optionGroup?.detailedGrouping?.displayType !== betBuilderDisplayType || shouldShowPrecreated;
                            renderCallback: render$;
                            strategy: renderStrategy$
                        "
                        [optionGroup]="optionGroup"
                        [event]="event"
                        [promoted]="!!promoted[optionGroup.templateId]"
                        [crmPromoted]="isCrmPromoted(optionGroup)"
                        [crmPromoIdsMap]="crmPromoIdsMap"
                        [tracking]="tracking"
                        [trackingModuleType]="trackingModuleType"
                        [showHelp]="true"
                        [thresholds]="getThresholds(optionGroup)"
                        [sourceOfPick]="sourceOfPick"
                        [hideEventCarousel]="hideEventCarousel"
                        [showEventName]="showEventName"
                        [showEventTimer]="showEventTimer"
                        [toggleable]="toggleable"
                        [isLinkToEvent]="isLinkToEvent"
                        [showEventChevron]="showEventChevron"
                        [showMoreCounter]="showMoreCounter"
                        [optionsLimitOverride]="optionsLimitOverride"
                        [babButtonSource]="babButtonSource"
                        [betBuilderEpcotEnabled]="betBuilderEpcotEnabled"
                        [collapsed]="getcollapsed(optionGroup, vm.marketOptionGroup)"
                        [hideMarketHeader]="hideMarketHeader"
                        [showSixPackLogosColor]="showSixPackLogosColor"
                        [showSixPackLogos]="showSixPackLogos"
                        [selectedSetId]="selectedSetId"
                        [marketLogoShow]="true"
                        [optionMarketSetData]="optionMarketSetData()"
                        [appendTooltipToWidgetSlot]="appendTooltipToWidgetSlot"
                        (eventTitleClicked)="onEventTitleClick()" />
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
